/**
 * ============================================================================
 * [P3-02-D] MetricCard - 단일 메트릭 카드 컴포넌트
 *
 * 개별 메트릭을 카드 형태로 표시
 * - 아이콘, 값, 단위, 라벨 표시
 * - 조건부 하이라이트 스타일
 * ============================================================================
 */

import { memo } from 'react'
import styles from './Tracking.module.css'

// ============================================================================
// Types
// ============================================================================
interface MetricCardProps {
  label: string
  value: string | number
  unit?: string
  icon?: string
  highlight?: boolean
}

// ============================================================================
// [P3-02-D] MetricCard Component
// - memo로 불필요한 리렌더링 방지
// ============================================================================
export const MetricCard = memo(function MetricCard({
  label,
  value,
  unit,
  icon,
  highlight,
}: MetricCardProps) {
  return (
    <div className={`${styles.metricCard} ${highlight ? styles.highlight : ''}`}>
      {/* 아이콘 */}
      {icon && <span className={styles.metricIcon}>{icon}</span>}

      {/* 콘텐츠 영역 */}
      <div className={styles.metricContent}>
        {/* 값 + 단위 */}
        <span className={styles.metricValue}>
          {value}
          {unit && <span className={styles.metricUnit}>{unit}</span>}
        </span>

        {/* 라벨 */}
        <span className={styles.metricLabel}>{label}</span>
      </div>
    </div>
  )
})

export default MetricCard
